// ════════════════════════════════════════════════════════════
// NotFound — page 404 cohérente (Sprint Shell)
// ════════════════════════════════════════════════════════════
// Sobre Linear. « 404 » en JetBrains Mono. Deux actions :
// retour à l'accueil (landing du rôle) + page précédente.
// Branchée sur notFoundComponent (root).
// ════════════════════════════════════════════════════════════
import { Link, useRouter } from '@tanstack/react-router';
import { Compass, ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/hooks/useAuth';
import { landingRouteForRole } from '@/types/auth';

export function NotFound() {
  const router = useRouter();
  const { profile } = useAuth();
  const home = landingRouteForRole(profile?.role);

  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center gap-6 px-6 text-center">
      <div className="bg-muted text-muted-foreground flex size-16 items-center justify-center rounded-2xl">
        <Compass className="size-8" />
      </div>

      <div className="space-y-2">
        <p className="text-muted-foreground font-mono text-5xl font-bold tabular-nums tracking-tight">
          404
        </p>
        <h1 className="text-foreground text-xl font-semibold tracking-tight">Page introuvable</h1>
        <p className="text-muted-foreground mx-auto max-w-sm text-sm">
          {"Cette page n'existe pas ou a été déplacée. Vérifie l'adresse ou reviens à l'accueil."}
        </p>
      </div>

      <div className="flex flex-col gap-2 sm:flex-row">
        <Button asChild>
          <Link to={home}>
            <Home className="size-4" />
            {"Retour à l'accueil"}
          </Link>
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            router.history.back();
          }}
        >
          <ArrowLeft className="size-4" />
          Page précédente
        </Button>
      </div>
    </div>
  );
}
